import setters from './setters';
import services from './services';
import logic from './logic';

export default { ...setters, ...services, ...logic };
